export const PATHS = {
  // unauth routes
  TUTORIAL_1: "/tutorial1",
  TUTORIAL_2: "/tutorial2",
  TUTORIAL_3: "/tutorial3",
  TUTORIAL_4: "/tutorial4",
  LOGIN: "/login",
  REGISTER: "/regist",
  REGIST5: "/regist5",
  REGIST6: "/regist6",
  REGIST_AGREE1: "/info/regist_agree1",
  REGIST_AGREE2: "/info/regist_agree2",
  FOREINGNER: "/info/foreigner",
  YOUNGER: "/info/younger",
  RESETPASSWORD: "/resetting_password",
  NEW_PASSWORD: "/resetting_password/new_password/:staff_id/:token",
  SEND_MAIL_SUCCESS: "/resetting_password/send_mail_success",
  NEW_PASSWORD_SUCCESS: "/resetting_password/new_password_success",
  ENTRY_POINT_TERMS: "/point-terms",

  // auth routes
  HOME: "/",
  SEARCH_MAP: "/search-map",
  JOB_DETAIL: "/job_detail",
  SEARCH_JOB: "/search",
  NEWS: "/news",
  NEWS_DETAIL: "/news_detail",
  MESSAGES: "/messages",
  MESSAGES_DETAIL: "/message_detail",
  JOB_APPLY: "/jobapply",
  JOB_PLAN: "/jobplan",
  JOB_WORK: "/jobwork",
  JOB_WORK_END_REPORT: "/jobworkendreport",
  JOB_RESULT_EMPLOYMENT: "/jobresult/employ",
  JOB_RESULT_SALARY: "/jobresult/salary",
  JOB_CONTRACT: "/jobcontract",
  SETTING: "/setting",
  SALARY: "/salary",
  COMPANY: "/company",
  PRIVACY_POLICY: "/privacy_policy",
  APP_POLICY: "/app_policy",
  CONTACT: "/contact",
  USER_GUIDE: "/user_guide",
  ABOUT_JOB: "/about_job",
  SUMAJOB_TERM: "/sumajobterm",
  PRINCIPLE: "/principle_prohibition",
  PASSWORD: "/password",
  PROFILE: "/profile",
  FAQ: "/faq",
  REGIST_MENU: "/official_registmenu",
  NO_CORRESPOND: "/no_correspond",
  REGIST_1: "/official_regist1",
  REGIST_2: "/official_regist2",
  REGIST_3: "/official_regist3",
  REGIST_FOREIGNER: "/regist_foreigner",
  OFFICIAL_REGIST_FOREIGNER: "/official_regist_foreigner",
  VIDEO: "/user/video",
  IMAGE_REGIST: "/user/imageregist",
  MYNO: "/user/myno",
  MY_CAR: "/user/mycar",
  EXPERIENCE: "/user/experience",
  UPLOAD_DOCUMENT: "/upload_documents",
  ABOUT_TRANSFER: "/about_transfer",
  MAKING_CONTRACT: "/makingcontract",
  WISH_LIST: "/wish-list",
  NEW_MESSAGE: "/new-message-notify",
  SETTING_NOTIFICATION: "/setting-notification",
  REDIRECT: "/redirect",
  STAFF_POINT_HISTORY: "/staff-point-history",
  STAFF_POINT_EXCHANGE: "/staff-point-exchange",
  STAFF_POINT_EXCHANGE_INFORMATION: "/point-exchange-information",
  SHIFT_STAFF_POINT: "/shift-staff-point",
  SHIFT_STAFF_POINT_DETAIL: "/shift-staff-point-detail",
};

export const MAPBOX_TOKEN = process.env.MIX_MAPBOX_API_KEY;
export const VAPID_PUBLIC_KEY = process.env.MIX_VAPID_PUBLIC_KEY;
